var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFonts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.926987 14.9829L0.905346 15.075H1H1.09098H1.10602L1.11991 15.0692L3.03954 14.2666L3.07485 14.2519L3.08362 14.2146L4.371 8.74379H8.81501H8.85361L8.87604 8.71238L9.895 7.28563L9.90426 7.27265L9.90745 7.25703L9.92565 7.16786L9.94401 7.07787H9.85216H4.78488C5.11185 5.98134 5.51158 5.11879 5.98203 4.48688C6.93248 3.21333 7.95596 2.59092 9.05155 2.59092C9.60046 2.59092 10.0492 2.74669 10.4035 3.0541C10.7589 3.36249 11.0257 3.82912 11.1991 4.46185L11.2142 4.51704H11.2714H11.3624H11.3777L11.3917 4.51107L13.0293 3.81553L13.0922 3.78884L13.0715 3.72377C12.777 2.79764 12.3246 2.09639 11.7104 1.62703C11.0959 1.15739 10.3261 0.925 9.40637 0.925C7.57568 0.925 5.92747 1.85669 4.46221 3.69974C3.62846 4.74527 3.00605 6.14456 2.59192 7.89355L2.59188 7.89368L0.926987 14.9829Z",
    fill: "#FFA318",
    stroke: "#FFC503",
    strokeWidth: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFonts);
export default __webpack_public_path__ + "static/media/fonts.24b90624.svg";
export { ForwardRef as ReactComponent };